const AddIcon = ({ backgroundFill, strokeColor, strokeWidth, width }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24" width={width}>
      <circle
        cx="11.55"
        cy="11.55"
        r="10.55"
        fill={backgroundFill}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <line
        x1="7.14"
        y1="11.55"
        x2="15.96"
        y2="11.55"
        fill={backgroundFill}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <line
        x1="11.55"
        y1="7.14"
        x2="11.55"
        y2="15.96"
        fill={backgroundFill}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default AddIcon;
